import React, { useState, createContext } from "react";

import Component from "./Component";

export const SimpleSnackbarContext = createContext({
  actions: {},
  store: {},
});

export const SimpleSnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: "",
    severity: null,
    duration: null,
    onClose: null,
  });

  const open = (message, { severity, duration, onClose }) => {
    setSnackbar({
      isOpen: true,
      severity,
      message,
      duration,
      onClose: onClose || null,
    });
  };

  const close = () => {
    if (snackbar.onClose && typeof snackbar.onClose === "function") {
      snackbar.onClose();
    }

    setSnackbar({
      isOpen: false,
      message: "",
      severity: null,
      duration: null,
      onClose: null,
    });
  };

  return (
    <SimpleSnackbarContext.Provider
      value={{
        actions: {
          open,
          close,
        },
        store: snackbar,
      }}
    >
      <Component />
      {children}
    </SimpleSnackbarContext.Provider>
  );
};
